import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const HodinoveSazby = {
	name: NAME,
	apiProvider,
	router,
};
